import { StickyNote } from 'lucide-react'
import { cn } from '@/utils/cn'
import './blocos.css'

interface BlocosFabProps {
  badgeCount: number
  onClick: () => void
}

export function BlocosFab({ badgeCount, onClick }: BlocosFabProps) {
  return (
    <div className='blocos-fab'>
      <button
        type='button'
        onClick={onClick}
        className={cn('blocos-fab__button relative')}
        aria-label={
          badgeCount > 0
            ? `Blocos, ${badgeCount} retornos pendentes`
            : 'Abrir blocos pessoais'
        }
      >
        <StickyNote size={22} strokeWidth={1.75} />
        {badgeCount > 0 && (
          <span className='blocos-fab__badge' aria-hidden>
            {badgeCount > 9 ? '9+' : badgeCount}
          </span>
        )}
      </button>
    </div>
  )
}
